import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames/bind';

import { DataBlocks, I18n, Preloader } from 'components';

import {
  AgreementRenewalRequest, RouterBuyRequests,
  DeviceBlock, InternetErrorBlock, InternetTariff, ServiceBlock, TariffPrice,
} from './components';

import { fetchUserInfo as fetchUserInfoAction } from './store/actions';
import styles from './styles.pcss';
import { getIsConvergenceUnavailableForYourRegion } from '../Home/selectors';
import { getFTTBError, getFTTBTariff } from './store/selectors';
import { UnavailableBlock } from './components/UnavailableBlock';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const cx = classNames.bind(styles);

const _Internet = ({ fetchUserInfo, tariff, error, isUnavailableForYourRegion }) => {
  useEffect(fetchUserInfo, []);

  if (isUnavailableForYourRegion) return <UnavailableBlock />;
  if (error) return <InternetErrorBlock />;
  if (!tariff) return <Preloader size="80" />;

  return (
    <DataBlocks.Container className={cx('page')}>
      <DataBlocks.Block
        title={<I18n path="internet.internet.blockTitle" />}
        info={<TariffPrice />}
      >
        <InternetTariff
          forms={(
            <>
              <AgreementRenewalRequest />
              <RouterBuyRequests />
            </>
            )}
        />
      </DataBlocks.Block>
      <ServiceBlock />
      <DeviceBlock />
    </DataBlocks.Container>
  );
};

const mapStateToProps = (state) => ({
  error: getFTTBError(state),
  tariff: getFTTBTariff(state),
  isUnavailableForYourRegion: getIsConvergenceUnavailableForYourRegion(state),
});

const mapDispatchToProps = {
  fetchUserInfo: fetchUserInfoAction,
};

_Internet.propTypes = {
  error: PropTypes.any,
  tariff: PropTypes.object,
  fetchUserInfo: PropTypes.func,

  // external
  isUnavailableForYourRegion: PropTypes.bool,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withViewAnalytics,
)(_Internet);
